// src/components/common/ThemeToggle.jsx
import React from 'react';
import { Button, Tooltip } from 'antd';
import { BulbOutlined, BulbFilled } from '@ant-design/icons';
import { useTheme } from '../../context/ThemeContext';

export default function ThemeToggle() {
    const { isDark, toggleMode } = useTheme();

    return (
        <Tooltip title={isDark ? 'Light mode' : 'Dark mode'}>
            <Button
                type="text"
                shape="circle"
                size="middle"
                aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
                icon={isDark ? <BulbFilled /> : <BulbOutlined />}
                onClick={toggleMode}
            />
        </Tooltip>
    );
}